module.exports = __webpack_public_path__ + "static/reviewer_2-2122aed6410becf55d00152a4ee85acf.png";